import { PRECACHE_DATA } from './constants';

export function precacheImages(images) {
  return dispatch => {
    dispatch({
      type: PRECACHE_DATA,
      data: images,
      mediaType: 'image',
      precache: true
    });
  };
}

export function precacheVideos(videos) {
  return dispatch => {
    dispatch({
      type: PRECACHE_DATA,
      data: videos,
      mediaType: 'video',
      precache: true
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/Precache/actions.js